import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { UnidadeGestoraModel } from 'app/model/cliente/unidadegestora';
import { ResponsePageable } from 'app/model/cliente/pageable/responsePageable.model';
import { Observable } from 'rxjs/Observable';
import { HttpClient, HttpHeaders } from '@angular/common/http';


@Injectable()
export class UnidadeGestoraService {

  apiURL = environment.API;

  httpOptions = {
    headers : new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('ticket', sessionStorage.getItem('ticket-ECM'))
  .set('Authorization', sessionStorage.getItem('tokenAuth'))
  };

  constructor(private httpClient: HttpClient) { }



  postUnidadeGestora(unidadegestora: UnidadeGestoraModel, idCliente: number): Observable<UnidadeGestoraModel> {
    // tslint:disable-next-line: max-line-length
    return this.httpClient.post<any>(this.apiURL + '/new/adicionar-unidadegestora/' + idCliente, unidadegestora, this.httpOptions);
  }

  putUnidadeGestora(unidadegestora: UnidadeGestoraModel): Observable<UnidadeGestoraModel> {
    return this.httpClient.put<UnidadeGestoraModel>(this.apiURL + '/edit/editar-unidadegestora', unidadegestora, this.httpOptions);
  }

  deleteUnidadeGestora(id: any) {
    const headers = new HttpHeaders()
    .set('ticket', sessionStorage.getItem('ticket-ECM'))
    .set('Authorization', sessionStorage.getItem('tokenAuth'));

    return this.httpClient.delete(this.apiURL + '/delete/delete-unidadegestora/' + id, { headers, responseType: 'text' });
  }

  getDescricaoUnidadeGestoraCliente(clienteId: any): Observable<any> {
    return this.httpClient.get<any>(this.apiURL + '/listar-unidadegestora-cliente/' + clienteId, this.httpOptions);
  }

  getUnidadeGestoraIdCliente(id: any): Observable<any> {
    return this.httpClient.get<any>(this.apiURL + '/view/listar-unidadegestoras-id-cliente/' + id, this.httpOptions);
  }

  getUnidadeGestoraCliente(id: any): Observable<any> {
    return this.httpClient.get<any>(this.apiURL + '/view/listar-unidadegestoras-cliente/' + id, this.httpOptions);
  }

  getPageUnidadeGestora(page, size): Observable<ResponsePageable> {
    return this.httpClient.get<ResponsePageable>(this.apiURL + `/view/listar-unidadegestoras?page=${page}&size=${size}`, this.httpOptions);
  }

  getAreas(): Observable<ResponsePageable> {
    return this.httpClient.get<ResponsePageable>(this.apiURL + '/view/listar-unidadegestoras', this.httpOptions);
  }

}



// WEBPACK FOOTER //
// /app/src/app/service/cliente/unidade-gestora.service.ts